import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, INSTITUTION, LOGO_URL } from "../data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-[#2D1B4E]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 2xl:px-14 flex items-center justify-between h-20">
        <a
          href="#inicio"
          data-testid="logo-link"
          className="flex items-center gap-3 group shrink-0"
        >
          <img
            src={LOGO_URL}
            alt="Escudo UPP"
            className="w-11 h-11 object-contain"
          />
          <span className="flex flex-col leading-none">
            <span className="font-serif-display text-xl font-semibold text-[#2D1B4E] tracking-tight">
              UPP
            </span>
            <span className="text-[10px] uppercase tracking-overline text-[#5F5670] mt-1 hidden sm:block max-w-[170px] leading-tight">
              Universidad Politécnica de Pachuca
            </span>
          </span>
        </a>

        <nav className="hidden 2xl:flex items-center gap-x-5">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-[12.5px] font-medium text-[#1A1523] hover:text-[#5B3E96] transition-colors whitespace-nowrap relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#5B3E96] hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="2xl:hidden text-[#2D1B4E]"
          aria-label="Menú"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="2xl:hidden bg-white border-t border-[#E8E4EE] px-6 py-4 flex flex-col gap-4 max-h-[70vh] overflow-y-auto"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#1A1523] hover:text-[#5B3E96]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
